import { render, staticRenderFns } from "./AppListItem.vue?vue&type=template&id=123a8e36"
import script from "./AppListItem.vue?vue&type=script&lang=js"
export * from "./AppListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports